import useSWR from "swr"

import { getCurrentBuildVersion } from "@/lib/get-current-build"

const COUNTY_GEOJSON_KEY = "COUNTY_GEOJSON_KEY"

const versionPromise = getCurrentBuildVersion()

export function useCurrentBuildVersion() {
  return useSWR([COUNTY_GEOJSON_KEY], () => versionPromise, {
    refreshWhenHidden: false,
    refreshWhenOffline: false,
    revalidateOnFocus: false,
    revalidateIfStale: false,
    revalidateOnReconnect: false,
  })
}
